import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminHeader, Card, Empty } from "@/components/admin/ui";

const LABEL = { MANUAL_ADJUSTMENT: "Manual Adjustment", ORDER_RESERVATION: "Order Reservation", STOCK_ADDED: "Stock Added" };

export default function AdminInventoryHistory() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/inventory/history").then(({ data }) => setRows(data.transactions)); }, []);
  return (
    <div>
      <AdminHeader title="Inventory History" subtitle="Auditable stock transactions" />
      <Card className="overflow-hidden">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="p-3">Date</th><th className="p-3">SKU</th><th className="p-3">Type</th><th className="p-3">Change</th><th className="p-3">Note</th><th className="p-3">By</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-slate-50">
                <td className="p-3 text-xs text-slate-500">{new Date(r.createdAt).toLocaleString("en-IN")}</td>
                <td className="p-3 font-mono text-xs">{r.sku || "—"}</td>
                <td className="p-3">{LABEL[r.type] || r.type}</td>
                <td className={`p-3 font-mono font-semibold ${r.quantity >= 0 ? "text-emerald-600" : "text-red-600"}`}>{r.quantity >= 0 ? "+" : ""}{r.quantity}</td>
                <td className="p-3 text-slate-500">{r.note}</td>
                <td className="p-3 text-xs text-slate-500">{r.actorEmail || "system"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <Empty />}
      </Card>
    </div>
  );
}
